import { Component, Input } from '@angular/core';
import { App, NavController, NavParams, ModalController } from 'ionic-angular';
import { CategoriesProvider, CategoryModel } from '../../../../providers/categories/categories';
import { AppDetectorProvider } from '../../../../providers/detector/detector';
import { EventDefineModel, EventDetailsModel } from '../../../../providers/event/event';
import { TextValueModel, ValueProvider } from '../../../../providers/value/value';
import { EventCreateRacePage } from '../event-create-race/event-create-race';

/**
 * Generated class for the EventCreatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-event-create',
  templateUrl: 'event-create.html',
})

export class EventCreatePage {

  @Input("eventModel")
  event: EventDetailsModel;

  categories: CategoryModel[] = [];
  countries: TextValueModel[] = [];
  states: TextValueModel[] = [];
  eventFromDate: string = new Date().toISOString();
  eventUntilDate: string = new Date().toISOString();
  eventDefine: EventDefineModel = { genderFromTo: "", price: 0, route1: 0, route2: null, route3: null, id: 0, time: "" };
  eventMaxYear = new Date().getFullYear() + 50;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    private valueService: ValueProvider,
    private app: App,
private detector: AppDetectorProvider,
    categoryService: CategoriesProvider
  ) {
    //this.eventDate = datePipe.transform(new Date(), "MM/DD/YYYY");
    console.log(this);


    categoryService.getEventCategoires().then((cat) => {
      console.log(cat);
      this.categories = cat;
      this.event.cid = cat[0].id;
    });

    valueService.getCountries().then((countries) => {
      this.countries = countries;
      this.event.country = countries[0].value;
    })

    valueService.getStates().then((states) => {
      this.states = states;
      this.event.state = states[0].value;
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EventCreatePage');
  }

  getRouteText(define: EventDefineModel) {
    //let rformat = (t?: number) => t ? t + "km" : "";
    return define.route1 + (define.route2 !== null ? "-" + define.route2 : "") + (define.route3 !== null ? "-" + define.route3 : "") + "km"
  }

  categoryChange(id: string) {
    let uni = this.categories.find(x => x.id === parseInt(id)).uniqueName.toLowerCase();

    if (uni.indexOf('duathlon') !== -1) {
      this.eventDefine.route2 = 0;
      this.eventDefine.route3 = 0;
    } else if (uni.indexOf('tri') !== -1) {
      this.eventDefine.route2 = 0;
      this.eventDefine.route3 = 0;
    } else {
      this.eventDefine.route2 = null;
      this.eventDefine.route3 = null;
    }
  }

  dateChange(a, b) {
    this.event[b] = new Date(a.year, a.month - 1, a.day).getTime();
  }

  keyUpChecker(ev) {
    let elementChecker: string;
    let format = /[0-9]{6,10}/;
    //console.log(ev);
    elementChecker = ev.target.value;
    if (format.test(elementChecker)) {
      this.event.plz = elementChecker.slice(0, -1);
    }
  }

  removeDefine(define: EventDefineModel) {
    let index = this.event.wertungList.findIndex(x => x.genderFromTo === define.genderFromTo && x.price === define.price && x.time === define.time && x.route1 === define.route1 && x.route2 === define.route2 && x.route3 === define.route3);
    this.event.wertungList.splice(index, 1);
  }

  webPageInsert() {
    if (this.event.webPage === "") {
      this.event.webPage = "https://"
    }
  }

  openAddDefine() {
    let raceModal = this.modalCtrl.create(EventCreateRacePage, {
      data: {
        event: this.event,
        define: this.eventDefine,
        isCreate: true
      }
    });
    raceModal.present();

    // (this.app.getRootNav() as NavController).push(EventCreateRacePage, {
    //   data: {
    //     event: this.event,
    //     define: this.eventDefine,
    //     isCreate: true
    //   }
    // });
  }

  editRace(def: EventDefineModel) {
    let raceModal = this.modalCtrl.create(EventCreateRacePage, {
      data: {
        event: this.event,
        define: this.eventDefine,
        isCreate: false
      }
    });
    raceModal.present();

    // (this.app.getRootNav() as NavController).push(EventCreateRacePage, {
    //   data: {
    //     event: this.event,
    //     define: this.eventDefine,
    //     isCreate: false
    //   }
    // });
  }
}



// WEBPACK FOOTER //
// /src/pages/event/create/event-create/event-create.ts